import React, { useState, useEffect } from "react";
import Grid from '@mui/material/Grid2';
import './MissingPieces.css'


function MissingPieces(props) {

    const player = props.player;

    const tomeCosts = {
        weapon: 500,
        head: 495,
        body: 825,
        hands: 495,
        legs: 825,
        feet: 495,
        ears: 375,
        neck: 375,
        wrists: 375,
        fingerL: 375,
        fingerR: 375
    }

    const sides = [['weapon', 'head', 'body', 'hands', 'legs', 'feet'], ['ears', 'neck', 'wrists', 'fingerL', 'fingerR']]
    const gear = ['weapon', 'head', 'body', 'hands', 'legs', 'feet', 'ears', 'neck', 'wrists', 'fingerL', 'fingerR']

    useEffect(() => {
        var acquiredRaidCount = 0;
        var acquiredTomeCount = 0;
        var acquiredShineCount = 0;
        var acquiredTwineCount = 0;
        var neededRaidCount = 0;
        var neededTomeCount = 0;
        var neededShineCount = 0;
        var neededTwineCount = 0;
        gear.forEach((gearPiece) => {
            if (player.neededGear[gearPiece] == 'raid') {
                neededRaidCount++;
                if (player.acquiredGear[gearPiece])
                    acquiredRaidCount++;
            }
            if (player.neededGear[gearPiece] == 'tome') {
                neededTomeCount += tomeCosts[gearPiece];
                if (player.acquiredGear[gearPiece])
                    acquiredTomeCount += tomeCosts[gearPiece];
                if (sides[0].includes(gearPiece) && gearPiece != 'weapon') {
                    neededTwineCount++;
                    if (player.augmented[gearPiece])
                        acquiredTwineCount++;
                }
                if (sides[1].includes(gearPiece)) {
                    neededShineCount++;
                    if (player.augmented[gearPiece])
                        acquiredShineCount++;
                }
            }
        })
        player['raidAcquired'] = acquiredRaidCount;
        player['raidNeeded'] = neededRaidCount;
        player['tomesAcquired'] = acquiredTomeCount;
        player['tomesNeeded'] = neededTomeCount;
        player['shinesAcquired'] = acquiredShineCount;
        player['shinesNeeded'] = neededShineCount;
        player['twinesAcquired'] = acquiredTwineCount;
        player['twinesNeeded'] = neededTwineCount;
        props.saveMissing(player);
    }, [player])

    return (
        <Grid container spacing={0} style={{ borderBottom: '1px solid black', backgroundColor: '#37373a', paddingTop: '3px', paddingBottom: '5px' }}>

            <Grid className="data" size={3}>
                {player.raidAcquired} / {player.raidNeeded} <img className="resource" src={require(`../FFXIVIcons/General/raid.png`)} />
            </Grid>
            <Grid className="data" size={4}>
                {player.tomesAcquired} / {player.tomesNeeded} <img className="resource" src={require(`../FFXIVIcons/General/tome.png`)} />
            </Grid>
            <Grid className="data" size={3}>
                {player.twinesAcquired} / {player.twinesNeeded} <img className="resource" src={require(`../FFXIVIcons/General/twine.png`)} />
            </Grid>
            <Grid className="data" size={2}>
                {player.shinesAcquired} / {player.shinesNeeded} <img className="resource" src={require(`../FFXIVIcons/General/shine.png`)} />
            </Grid>

        </Grid>
    );
}

export default MissingPieces;